import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { stopSharingPollResultsRequested } from 'features/polls/actions';

export function* stopSharingPollResultsSaga(
  action: ReturnType<typeof stopSharingPollResultsRequested>
) {
  yield call(SignalingSocket.send, {
    event: 'stopSharingPollResults',
    data: {
      id: action.payload,
    },
  });
}
